var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return !_setup.isMobile
    ? _c(_setup.InfoLayout, {
        attrs: {
          "current-path": _setup.reverseFull({ name: "about_us" }),
          "is-policy": false,
        },
        scopedSlots: _vm._u(
          [
            {
              key: "title",
              fn: function () {
                return [
                  _vm._v(
                    "\n    " +
                      _vm._s(_setup.t("О проекте", _setup.options)) +
                      "\n  "
                  ),
                ]
              },
              proxy: true,
            },
            {
              key: "content",
              fn: function () {
                return [
                  _c(_setup.MainContent, {
                    attrs: {
                      "info-records": _setup.context.info_records,
                      "info-id": _setup.context.info.id,
                      "team-members": _setup.context.team_members,
                      "is-super-user":
                        !!_setup.context.request.user?.is_superuser,
                      "is-editor-user": _setup.hasGroup(
                        _setup.context.request,
                        "editor_group"
                      ),
                      "site-name": _setup.context.request.site.name,
                    },
                  }),
                ]
              },
              proxy: true,
            },
          ],
          null,
          false,
          1101954915
        ),
      })
    : _c(
        "div",
        [
          _c(_setup.MainContent, {
            attrs: {
              "info-records": _setup.context.info_records,
              "info-id": _setup.context.info.id,
              "team-members": _setup.context.team_members,
              "is-super-user": !!_setup.context.request.user?.is_superuser,
              "is-editor-user": _setup.hasGroup(
                _setup.context.request,
                "editor_group"
              ),
              "site-name": _setup.context.request.site.name,
            },
          }),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }